import React from "react";
import { useSelector } from "react-redux";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { formattedCurrencyValue } from "../../utils/tableDataFormatter";

const BoxCompontent = ({
  title,
  value,
  percentageValue,
  volume,
  children,
  className = "",
}) => {
  const { t, i18n } = useTranslation();
  const volumeUnit = useSelector((state) => state.volume);
  const currency = useSelector((state) => state.currency);

  if (children) {
    return <div className={`box-container ${className}`}>{children}</div>;
  }

  value = isNaN(value)
    ? ""
    : value < 0
    ? ` ${formattedCurrencyValue(value, currency)}`
    : ` ${formattedCurrencyValue(value, currency)}`;

  const getClassname = (value) => {
    return parseFloat(value) <= 0
      ? "negative-box-information"
      : "box-information";
  };

  return (
    <div className={`box-container ${className}`}>
      <div className="box-title">{title}</div>
      {percentageValue && (
        <div className={`${getClassname(percentageValue)} marginTop10`}>
          {parseFloat(percentageValue).toFixed(2)}{" "}
          {percentageValue === "-Infinity" ? "" : "%"}
        </div>
      )}
      {volume && (
        <div className={`${getClassname(volume)} marginTop10 flex-jc-center `}>
          {value && <span>{value}</span>}{" "}
          <span>&nbsp; {t("ValueStrings.bracketOpen")}</span> &nbsp;
          {parseFloat(volume).toFixed(2)}{" "}
          {volumeUnit === "m3" ? (
            <span>
              &nbsp; m<sup>3</sup>
            </span>
          ) : (
            volumeUnit
          )}
          &nbsp;<span>{t("ValueStrings.bracketClose")}</span>
        </div>
      )}
      {value && !volume && (
        <div className={`${getClassname(value)} marginTop10`}>{value}</div>
      )}
    </div>
  );
};

export default BoxCompontent;
